import Form from "./Form";
import { useToast } from "@chakra-ui/react";
import {
  CreateCategoryMutationVariables,
  useCreateCategoryMutation,
} from "../../generated/graphql";
import { useNavigate } from "react-router-dom";

const Create = () => {
  const [createCategory] = useCreateCategoryMutation();
  const navigation = useNavigate();
  const toast = useToast();
  const handleCreateCategory = async (data: CreateCategoryMutationVariables) => {
    try {
      await createCategory({
        variables: {
          data: data.data,
        },
      });

      return toast({
        status: "success",
        title: "Success",
        description: "Category added",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/category");
        },
      });
    } catch (error) {
      return toast({
        status: "error",
        title: "Error",
        description: "An error occured",
        duration: 1000,
      });
    }
  };
  return <Form handleCreateCategory={handleCreateCategory} actionType="CREATE" />;
};

export default Create;
